import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-deanmsg',
  templateUrl: './deanmsg.component.html',
  styleUrls: ['./deanmsg.component.scss']
})
export class DeanmsgComponent implements OnInit {

  constructor(private seo: SeoService) {

  }

  ngOnInit(): void {
    this.seo.setMeta('Message from the Dean of the Faculty of Humanities & Social Sciences',
      'Dean, Humanities, Social Sciences')
  }

}
